"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationActions = void 0;
/* eslint-disable max-len */
const core_1 = require("@bluebase/core");
exports.NavigationActions = (0, core_1.getComponent)('NavigationActions');
